import immutableUpdate from 'immutable-update'
import dot from 'dot-object'
import { 
  isString,
  isObject,
  clone
} from 'lodash'

function APIClass(){

  return {
    
    data: {},

    setData: function(data) {

      this.data = immutableUpdate(this.data, data)
    },

    ispringdata: {},

    setISpringData: function(data) {

      this.ispringdata = immutableUpdate(this.ispringdata, data)
    },
      
    LMSInitialize: function() {	

      // console.log('LMSInitialize')
          
      return "true";
    },

    LMSCommit: function() {

      const fetchdata = new FormData()
      
      fetchdata.append('userid', window.academystatus.userid)  
      fetchdata.append('academycourseid', window.academystatus.courseid)  
      fetchdata.append('scormdata', JSON.stringify(this.data))
      fetchdata.append('ispringslidestotal', this.ispringdata.ispringslidestotal)  
      fetchdata.append('ispringslideslastvisited', this.ispringdata.ispringslideslastvisited)   
      fetchdata.append('ispringslidesactualvisited', this.ispringdata.ispringslidesactualvisited)  
      fetchdata.append('completed', this.data.cmi.core.lesson_status) 

      fetch(
        '/wp-json/academy/scorm/write', 
        {
          method: 'POST',
          headers: {
            'X-WP-Nonce': academy_web_site.nonce
          },
          body: fetchdata
        }
      )
      .then(response => {

        if(response.status == 200){
        
          response.json().then(result => {

            // console.log(result)            
          })

        } else {

          console.log(response)     
        }
      })
      .catch(error => {
        
        console.log(error)
      })

      return "true";
    },

    LMSSetValue: function(element, value) {

      // console.log('LMSSetValue');

      this.setData(dot.str(element, value, {}))

      return "true";
    },

    LMSGetValue: function(element) {
          
      const value = dot.pick(element, this.data)

      return value || '';
    },

    LMSGetLastError: function(){

      // console.log('LMSGetLastError');
    },	

    LMSGetErrorString: function(errorCode){

      // console.log('LMSGetErrorString: ' + errorCode);

      return errorCode;
    },	

    LMSGetDiagnostic: function(errorCode){
      
      // console.log('LMSGetDiagnostic:' + errorCode)

      return errorCode;
    },

    LMSFinish: function() { 

      const time = this.data.cmi.core.session_time
      .split(':')
      .reduce((seconds, part, index) => {

        let partn = parseInt(part)

        switch(index) {
          case 0: partn *= 60 * 60; break
          case 1: partn *= 60; break
        }

        seconds = seconds + partn

        return seconds
      }, 0)     

      const fetchdata = new FormData()
      
      fetchdata.append('userid', window.academystatus.userid)  
      fetchdata.append('academycourseid', window.academystatus.courseid)  
      fetchdata.append('scormdata', JSON.stringify(this.data))
      fetchdata.append('ispringslidestotal', this.ispringdata.ispringslidestotal)  
      fetchdata.append('ispringslideslastvisited', this.ispringdata.ispringslideslastvisited)   
      fetchdata.append('ispringslidesactualvisited', this.ispringdata.ispringslidesactualvisited)  
      fetchdata.append('completed', this.data.cmi.core.lesson_status)  
      fetchdata.append('sessiontime', time)

      fetch(
        '/wp-json/academy/scorm/write', 
        {
          method: 'POST',
          headers: {
            'X-WP-Nonce': academy_web_site.nonce
          },
          body: fetchdata
        }
      )
      .then(response => {

        if(response.status == 200){
        
          response.json().then(result => {

            // console.log(result)            
          })

        } else {

          console.log(response)     
        }
      })
      .catch(error => {
        
        console.log(error)
      })

      return "true";
    },
  }
}

window.API = new APIClass()